const prismicKey = Symbol("prismic");
export {
  prismicKey
};
//# sourceMappingURL=injectionSymbols.js.map
